export class CustomerNote {
    content: string
  
    constructor(content: string) {
      this.content = content
    }
  }